import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type ArtifactNodeType = Node<NodeData, 'custom_artifact'>;

export const ArtifactNode: React.FC<NodeProps<ArtifactNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const inputPort = 'data';
  const artifactName = (data.config?.name as string) || 'artifact';
  const description = data.config?.description as string;

  let subtitle = `Name: ${artifactName}`;
  if (description) {
    subtitle += ` - ${description}`;
  }

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="io"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handle for artifact blocks (sink node - no outputs) */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id={inputPort}
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, inputPort))
            : undefined
        }
      />
    </BaseNode>
  );
};